import actionTypes from '../actionTypes';

export function requestGameBoxMission() {
  return {
    type: actionTypes.GAME_BOX_MISSION_REQUEST,
  };
}

export function successGameBoxMissions(missions: any) {
  return {
    type: actionTypes.GAME_BOX_MISSION_SUCCESS,
    value: missions,
  };
}


export function updateGameBoxMission(gameBoxData: any[]) {
  return {
    type: actionTypes.GAME_BOX_MISSION_UPDATE,
    value: gameBoxData,
  };
}

export function failGameBoxMission(e: any) {
  return {
    type: actionTypes.GAME_BOX_MISSION_FAIL,
    exception: e,
  };
}

export function successGameBoxRaffle(raffles: { id: any; type: string; tooltipText: string; name: string; prizePool: any; currency: string; accountTicket: any; endDate: any; trigger: any; progress: any; } | null) {
  return {
    type: actionTypes.GAME_BOX_JACKPOT_SUCCESS,
    value: raffles,
  };
}

export function failGameBoxRaffle() {
  return {
    type: actionTypes.GAME_BOX_JACKPOT_FAIL,
  }
}

export function successGameBoxRaffleTicket(raffles: any) {
  return {
    type: actionTypes.GAME_BOX_JACKPOT_TICKETS_SUCCESS,
    value: raffles,
  };
}

export function requestGameBoxRaffleTickets() {
  return {
    type: actionTypes.GAME_BOX_JACKPOT_TICKETS_REQUEST
  }
}

export function requestGameBoxRaffle() {
  return {
    type: actionTypes.GAME_BOX_JACKPOT_REQUEST,
  }
}

export function requestGameBoxRaffleUpdate() {
  return {
    type: actionTypes.GAME_BOX_JACKPOT_UPDATE_REQUEST,
  }
}

export function updateGameBoxRaffle(raffles: { accountTicket: any; prizePool: any; trigger: any; progress: any; } | null) {
  return {
    type: actionTypes.GAME_BOX_JACKPOT_UPDATE,
    value: raffles
  }
}

export function requestCasinoNextInstances(tourInstanceId: { tourInstanceId: any; templateId: any }, templateId?: any) {
  return {
    type: actionTypes.CASINO_TOURNAMENT_NEXT_INSTANCES,
    value: { tourInstanceId, templateId }
  }
}

export function resetPrevDataGameBoxRaffle() {
  return {
    type: actionTypes.GAME_BOX_JACKPOT_RESET_PREV_DATA,
  }
}

export function successCasinoTournamentNextInstance(instance: { id: any; type: string; tooltipText: string; name: string; prizePool: any; currency: any; accountTicket: null; endDate: any; tournamentData: any } | null) {
  return {
    type: actionTypes.CASINO_TOURNAMENT_NEXT_INSTANCE_SUCCESS,
    value: instance
  };
}

export function resetPrevDataCasinoTournamentNextInstance() {
  return {
    type: actionTypes.CASINO_TOURNAMENT_NEXT_INSTANCE_RESET_PREV_DATA,
  }
}

export function failCasinoTournamentNextInstance(season?: any) {
  return {
    type: actionTypes.CASINO_TOURNAMENT_NEXT_INSTANCE_FAILURE,
    value: season ? season : null
  };
}

export function setGameBoxTag(tag: any) {
  return {
    type: actionTypes.SET_GAME_BOX_TAG,
    selected: tag
  }
}

export function setGameBoxMissionCount(count: number) {
  return {
    type: actionTypes.SET_GAME_BOX_MISSION_COUNT,
    value: count
  }
}